import React from 'react'
import { Dropdown, Menu, Tooltip } from 'antd'
import { IconMoreVertical } from '@edulastic/icons'
import { themeColor, themeColorBlue, white } from '@edulastic/colors'
import styled from 'styled-components'
import { segmentApi } from '@edulastic/api'
import withRouter from 'react-router/withRouter'
import EduButton from './EduButton'
import { StyledLink } from './HeaderTabs'

const TabDropdown = ({ tabs, onClickHandler, history }) => {
  const handleDropDownTabClick = (tab) => {
    const { disabled, to, segmentEventData = {} } = tab
    if (disabled) return
    if (to && to !== '#') {
      // we are sending a place to route
      history.push(to)
    } else if (typeof onClickHandler === 'function') {
      // call the onClickHandler passed from component
      onClickHandler(tab)
    }

    if (segmentEventData?.eventName) {
      segmentApi.genericEventTrack(segmentEventData.eventName, {
        ...(segmentEventData?.eventData || {}),
      })
    }
  }
  return (
    <Dropdown
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      overlay={
        <ClassDropMenu>
          {tabs.map((tab) => (
            <MenuItems disabled={tab.disabled} key={tab.name}>
              <StyledMenuLinkItem
                key={tab.key}
                id={tab.key}
                data-cy={tab.dataCy || tab.key}
                disabled={tab.disabled}
                to={tab.to}
                onClick={() => handleDropDownTabClick(tab)}
              >
                <Tooltip
                  title={
                    tab.disabled && tab.disabledMessage
                      ? tab.disabledMessage
                      : null
                  }
                  placement="left"
                >
                  {tab.name}
                </Tooltip>
              </StyledMenuLinkItem>
            </MenuItems>
          ))}
        </ClassDropMenu>
      }
      trigger={['click']}
    >
      <EduButton isGhost IconBtn>
        <IconMoreVertical color={themeColor} width="100%" />
      </EduButton>
    </Dropdown>
  )
}
export default withRouter(TabDropdown)

export const DropMenu = styled(Menu)`
  margin-top: 10px;
  min-width: 175px;
`

export const ClassDropMenu = styled(DropMenu)`
  margin-top: 0px;
  max-width: 300px;
  max-height: calc(100vh - 100px);
  overflow: auto;

  .ant-dropdown-menu-item-selected {
    a {
      color: ${themeColor};
      background: ${white};
      font-weight: 700;
    }
  }

  .ant-dropdown-menu-item-selected:hover {
    a {
      color: ${white};
      background: ${themeColor};
    }
  }
`

const MenuItems = styled(Menu.Item)`
  font-size: 12px;

  &:not(.ant-dropdown-menu-item-disabled):hover {
    color: ${white};
    background-color: ${themeColorBlue};
    > a {
      color: ${white};
    }
  }
`
const StyledMenuLinkItem = styled(StyledLink)`
  opacity: 1;
`
